import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { IStep } from "../interface"
import { 
    ButtonContainer, 
    ContainerDropzone, 
    RowForButton, 
    RowForInput, 
    TitleField 
} from "./style"
import Button from "../../Button";
import Dropzone from "../../Dropzone";
import { closeModal } from "../../../helpers/modalFunctions";
import { ToastContainer } from "react-toastify";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { addImageProduct } from "../../../hooks/addImageProduct";
import { TIME_INFO, TIME_RESULT } from "../../../utils/notifications/time";

const StepThree = ({
    setStep,
    data,
    setData
}: IStep) => {
    const [imgProduct, setImgProduct] = useState<File>(new File([""], ""));
    const INITIAL_STEP = 1

    return (
        <div>
            <ToastContainer/>
            <Formik
                initialValues={{
                    image: ""
                }}
                onSubmit={async () => {
                    const {isError} = await addImageProduct(imgProduct, data?.id as string)
                    
                    if(isError) {
                        toastUpdate("submitImg", "error", TIME_RESULT, "Falha ao enviar imagem. Tente outra imagem ou contate o suporte")
                    }

                    else {
                        toastUpdate("submitImg", "success", TIME_RESULT, "Imagem enviada com sucesso")
                        setImgProduct(new File([""], ""))
                    }
                }}
            >
                <Form>
                        <TitleField>
                            Você pode inserir várias imagens do seu produto
                        </TitleField>
                    <RowForInput>
                        <ContainerDropzone>
                            <div className="w-100">
                                <Field name="image" id="image" onFileUploaded={setImgProduct} type="image/png" as={Dropzone} />
                                <div className="d-flex justify-content-center mt-2">
                                <Button 
                                    onClick={() => {
                                        toastCreate(
                                            "submitImg", 
                                            "info", 
                                            TIME_INFO, 
                                            "Processando"
                                        )
                                    }} 
                                    type="submit">
                                        Adicionar imagem
                                </Button>
                                </div>
                            </div>
                        </ContainerDropzone>
                    </RowForInput>
                    <RowForButton>
                        <ButtonContainer>
                            <Button 
                                onClick={() => {
                                    closeModal("addProduct")
                                    setStep(INITIAL_STEP)
                                    setData && setData({
                                        active: false,
                                        amount: "",
                                        branchsId: "",
                                        created_at: "",
                                        description: "",
                                        groupId: "",
                                        id: "",
                                        updated_at: ""
                                    })
                                }} 
                                type="button">
                                    Finalizar produto
                            </Button>
                        </ButtonContainer>
                    </RowForButton>
                </Form>
            </Formik>
        </div>
    )
}

export default StepThree